import styled from 'styled-components';
import { COLORS } from '../../../../../../../constants/radar';

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 0;
`;

export const TagOption = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 6px 12px;
  margin: 2px 0;
  border: 1px solid ${props => props.selected ? COLORS.PRIMARY : '#ddd'};
  background-color: ${props => props.selected ? `${COLORS.PRIMARY}10` : '#fff'};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  color: ${COLORS.PRIMARY};
  font-weight: 500;

  &:hover {
    background-color: ${props => props.selected ? `${COLORS.PRIMARY}20` : COLORS.BACKGROUND};
  }
`;

export const TagIcon = styled.span`
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  color: ${COLORS.SECONDARY};
`;

export const TagCount = styled.span`
  margin-left: 4px;
  font-size: 0.8em;
  color: ${COLORS.SECONDARY};
`;

export const Label = styled.label`
  font-weight: 500;
  color: ${COLORS.PRIMARY};
  font-size: 14px;
`;

export const Field = styled.div`
  width: 100%;
  padding-bottom: 24px;
`;
